import { json, type ActionFunctionArgs } from '@remix-run/node';
import { z } from 'zod';
import { updateConversation } from '~/modules/chat/api/update-conversation.server';

export const UPDATE_CONVERSATION_API = '/remix-api/chat/update-conversation';

const FORM_DATA_SCHEMA = z.object({
    conversationID: z.coerce.number().int().positive(),
    name: z
        .string()
        .trim()
        .max(100)
        .transform((value) => value.replace(/\s+/, ' '))
        .nullish(),
});

/**
 * API endpoint to update the settings of a conversation. Use with the
 * `useUpdateConversation` hook.
 * @see {@link packages/web/app/modules/chat/hooks/use-update-conversation.ts}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const response = await updateConversation({
            context,
            conversationID: result.data.conversationID,
            name: result.data.name,
        });

        if (!response) {
            return json(null, { status: 500 });
        }

        return json({ conversation: response.conversation });
    } catch (error) {
        logger.error(`Error in ${UPDATE_CONVERSATION_API}`, {
            error,
            data: result.data,
        });
        return json(null, { status: 500 });
    }
};
